// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1qqE6","head":"ProcedureTableInfo_head__3HEF1"};